import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Sleep } from '../../../services/sleep';

@Component({
    selector: 'psm-field-validation',
    templateUrl: 'fieldValidation.component.html'
})
export class FieldValidationComponent implements OnChanges {

    /**
     * The <input> control we are displaying validation errors for
     */
    @Input('control') public control: FormControl;

    /**
     * Whether or not we should force the display of errors, even if the input wasn't touched
     */
    @Input('forceDisplay') public forceDisplay: boolean;

    @Input('validMessage') public validMessage: string;
    @Input('pendingMessage') public pendingMessage: string;

    private touched: boolean;
    private errors: any;

    /**
     * Gets or sets the error message to display
     */
    public errorMessage: string;

    constructor(private translate: TranslateService, private sleep: Sleep) {
    }

    public async ngOnChanges(changes: SimpleChanges) {
        let changed: boolean;

        if (!this.control) {
            return;
        }

        // Detect touched-related changes
        if (this.touched !== this.control.touched) {
            this.touched = this.control.touched;
            changed = true;
        }

        // Detect errors-related changes
        if (JSON.stringify(this.errors) !== JSON.stringify(this.control.errors)) {
            this.errors = this.control.errors;
            changed = true;
        }

        // Detect forceDisplay changes
        if (changes.forceDisplay) {
            changed = true;
        }

        if (changed) {
            await this.updateErrorMessage();
        }
    }

    public async ngOnInit() {
        if (!this.control) {
            return;
        }

        await this.updateErrorMessage();

        this.control.valueChanges.subscribe(async () => {
            await this.updateErrorMessage();
        });

        this.control.statusChanges.subscribe(async () => {
            await this.updateErrorMessage();
        });
    }

    private async updateErrorMessage() {
        this.errorMessage = await this.getErrorMessage();
    }

    /**
     * Gets the error message
     */
    public async getErrorMessage(): Promise<string> {

        if (!this.control) {
            return undefined;
        }

        while (this.control.pending) {
            await this.sleep.sleep(100);
        }

        let errors = this.control.errors;
        for (let propertyName in errors) {
            if (errors.hasOwnProperty(propertyName)) {

                let shouldDisplay = this.control.touched || this.forceDisplay;
                if (!shouldDisplay) {
                    return undefined;
                }

                let msg = await this.translate.get(propertyName).toPromise();
                return msg;
            }
        }

        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/fieldValidation/fieldValidation.component.ts